import { createAction, props } from '@ngrx/store'

const SOURCE = '[Project dialog]'

export const resetProjectArea = createAction(`${ SOURCE } ResetProjectArea`)

export const resetProjectConcernedSubject = createAction(`${ SOURCE } ResetProjectConcernedSubject`)

export const resetProjectToDtsrcSubject = createAction(`${ SOURCE } ResetProjectToDtsrcSubject`)

export const resetProjectLv = createAction(`${ SOURCE } ResetProjectLv`)

export const resetProjectPar = createAction(`${ SOURCE } ResetProjectPar`)

export const setProjectConcernedSubjectProperty = createAction(
    `${ SOURCE } setProjectConcernedSubjectProperty`,
    props<{property: string; value: any}>()
)

export const setProjectToDtsrcSubjectProperty = createAction(
    `${ SOURCE } SetProjectToDtsrcSubjectProperty`,
    props<{property: string; value: any}>()
)

export const setProjectArea = createAction(
    `${ SOURCE } SetProjectArea`,
    props<{area: any}>()
)

export const setProjectAreaProperty = createAction(
    `${ SOURCE } setProjectAreaProperty`,
    props<{property: string; value: any}>()
)

export const setProjectConcernedSubject = createAction(
    `${ SOURCE } SetProjectConcernedSubject`,
    props<{concernedSubject: any}>()
)

export const setProjectToDtsrcSubject = createAction(
    `${ SOURCE } SetProjectToDtsrcSubject`,
    props<{toDtsrcSubject: any}>()
)

export const setProjectLv = createAction(
    `${ SOURCE } SetProjectLv`,
    props<{lv: any}>()
)

export const setProjectLvProperty = createAction(
    `${ SOURCE } setProjectLvProperty`,
    props<{property: string; value: any}>()
)

export const setProjectPar = createAction(
    `${ SOURCE } SetProjectPar`,
    props<{par: any}>()
)

// --- effects

export const setArea = createAction(
    `${ SOURCE } SetArea`,
    props<{area: any}>()
)

export const setLv = createAction(
    `${ SOURCE } SetLv`,
    props<{lv: any}>()
)